import React, { HTMLAttributes } from "react";
import "./Glitch.css";
import clsx from "clsx";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            position: "relative",
        },
        mainItem: {
            position: "relative",
            zIndex: 20,
        },
        glitchItem: {
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            height: "100%",
            width: "100%",
        },
        glitchColouredBackground: { opacity: 0.8 },
        glitchColouredBackgroundPrimary: {
            left: 5,
            color: theme.palette.primary.main,
            zIndex: 2,
            animation:
                "glitch-one 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) alternate-reverse infinite",
        },
        glitchColouredBackgroundSecondary: {
            color: theme.palette.secondary.main,
            left: 4,
            zIndex: 1,
            animation:
                "glitch-one 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) alternate-reverse both infinite",
        },
        glitchPositionPrimary: {
            left: 2,
            textShadow: `-4px 0 ${theme.palette.primary.main}`,
            clip: "rect(24px, 550px, 90px, 0)",
            animation: "glitch-two-primary 3s infinite linear alternate-reverse",
            zIndex: 10,
        },
        glitchPositionSecondary: {
            left: 1,
            textShadow: `-3px 0 ${theme.palette.secondary.main}`,
            clip: "rect(85px, 550px, 140px, 0)",
            animation: "glitch-two-secondary 2.5s infinite linear alternate-reverse",
            zIndex: 11,
        },
        glitchShadowPrimary: {
            left: -2,
            color: theme.palette.primary.main,
            clip: "rect(24px, 550px, 90px, 0)",
            animation: "glitch-two-primary 3s infinite linear alternate-reverse",
            zIndex: 10,
        },
        glitchShadowSecondary: {
            left: -2,
            color: theme.palette.secondary.main,
            clip: "rect(85px, 550px, 140px, 0)",
            animation: "glitch-two-secondary 2.5s infinite linear alternate-reverse",
            zIndex: 11,
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function Glitch(props: IProps) {
    const { className, children, ...rest } = props;
    const classes = useStyles();

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            <div className={classes.mainItem}>{children}</div>

            <div
                className={clsx(
                    classes.glitchItem,
                    classes.glitchColouredBackground,
                    classes.glitchColouredBackgroundPrimary
                )}
            >
                {children}
            </div>
            <div
                className={clsx(
                    classes.glitchItem,
                    classes.glitchColouredBackground,
                    classes.glitchColouredBackgroundSecondary
                )}
            >
                {children}
            </div>

            <div className={clsx(classes.glitchItem, classes.glitchPositionPrimary)}>
                {children}
            </div>
            <div className={clsx(classes.glitchItem, classes.glitchPositionSecondary)}>
                {children}
            </div>

            <div className={clsx(classes.glitchItem, classes.glitchShadowPrimary)}>{children}</div>
            <div className={clsx(classes.glitchItem, classes.glitchShadowSecondary)}>
                {children}
            </div>
        </div>
    );
}
